"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.pollRootStyles = void 0;

var _emotion = require("emotion");

var _themeConfig = _interopRequireDefault(require("@lyearn-team/theme-config"));

var pollRootStyles =
/*#__PURE__*/
(0, _emotion.css)("width:100%;height:100vh;background-color:", _themeConfig.default.color.dark.saturn, ";display:flex;padding:24px 20px;");
exports.pollRootStyles = pollRootStyles;